import { Grid2 as Grid } from "@mui/material";
import {
	FormControl,
	InputLabel,
	MenuItem,
	Select,
	SelectChangeEvent,
} from "@mui/material";
import type { Theme } from "@mui/material/styles";
import { makeStyles } from "@mui/styles";
import React from "react";
import { MonthPicker } from "./MonthPicker";

const useStyles = makeStyles((theme: Theme) => ({
	formControl: {
		width: "100%",
		minWidth: 150,
		backgroundColor: "#FFFFFF !important",
		marginBottom: "4px !important",
		"& .MuiOutlinedInput-root": {
			height: 45,
			display: "flex",
			alignItems: "center",
			"&.Mui-focused": {
				outline: "none",
				"& .MuiOutlinedInput-notchedOutline": {
					borderColor: "rgba(0, 0, 0, 0.23)",
					borderWidth: 1,
				},
			},
		},
		"& .MuiSelect-select": {
			display: "flex",
			alignItems: "center",
			paddingTop: "0 !important",
			paddingBottom: "0 !important",
			"&:focus": {
				backgroundColor: "transparent",
			},
		},
	},
	monthPicker: {
		minWidth: 150,
	},
}));

// TODO: harcode
const ASSET_OPTIONS = [
	{ id: null, name: "ALL" },
	{ id: 11, name: "EAF 1" },
	{ id: 12, name: "EAF 2" },
];

type Props = {
	onMonthChange: (month: Date | null) => void;
	onAssetChange: (assetId: number | null) => void;
	selectedMonth: Date;
	selectedAsset: number | null;
};

export const Filters: React.FC<Props> = ({
	onMonthChange,
	onAssetChange,
	selectedMonth,
	selectedAsset,
}) => {
	const classes = useStyles();

	const handleMonthChange = (date: Date | null) => {
		onMonthChange(date);
	};

	const handleAssetChange = (event: SelectChangeEvent<number | "null">) => {
		const value = event.target.value;
		const assetId = value === "null" ? null : Number(value);
		onAssetChange(assetId);
	};

	return (
		<Grid container spacing={2} alignItems="flex-end" justifyContent="center">
			<Grid size={{ xs: 7 }}>
				<div className={classes.monthPicker}>
					<MonthPicker
						label="Month"
						value={selectedMonth}
						onChange={handleMonthChange}
					/>
				</div>
			</Grid>
			<Grid size={{ xs: 5 }}>
				<FormControl variant="outlined" className={classes.formControl}>
					<InputLabel>Asset</InputLabel>
					<Select
						value={selectedAsset === null ? "null" : selectedAsset}
						label="Asset"
						onChange={handleAssetChange}
					>
						{ASSET_OPTIONS.map((option) => (
							<MenuItem
								key={option.id ?? "all"}
								value={option.id === null ? "null" : option.id}
							>
								{option.name}
							</MenuItem>
						))}
					</Select>
				</FormControl>
			</Grid>
		</Grid>
	);
};
